/**
 * Centralized action types for file uploads across the application.
 * These match the backend's FileObject::ALLOWED_ACTION_TYPES
 */

export const FILE_ACTION_TYPES = {
  // User related
  avatar: {
    name: "avatar",
    dbname: "picture",
    accept: ["image/jpeg,image/png,image/webp"],
    extensions: ["jpg", "jpeg", "png", "webp",],
  },

  // Project related
  project_banner: {
    name: "project_banner",
    dbname: "bannerPicture",
    accept: ["image/jpeg,image/png,image/webp"],
    extensions: ["jpg", "jpeg", "png", "webp",],
  },
  project_image: {
    name: "project_image",
    dbname: "picture",
    accept: ["image/jpeg,image/png,image/webp"],
    extensions: ["jpg", "jpeg", "png", "webp",],
  },
  project_resource: {
    name: "project_resource",
    dbname: "file",
    accept: ["image/jpeg,image/png,image/webp,application/pdf,text/plain," +
    "application/msword,application/vnd.ms-office,application/xml,text/xsl,text/xml," +
    "application/vnd.ms-excel,text/csv,application/powerpoint,application/vnd.ms-powerpoint"],
    extensions: [".jpg", ".jpeg", ".png", "webp", ".pdf", ".txt", ".doc", ".docx", ".xls", ".xlsx", ".csv", ".ppt", ".pptx",],
  },

  // Organization related
  organization_banner: {
    name: "organization_banner",
    dbname: "banner",
    accept: ["image/jpeg,image/png,image/webp"],
    extensions: [".jpg", ".jpeg", ".png", "webp"],
  },
  organization_logo: {
    name: "organization_logo",
    dbname: "logo",
    accept: ["image/jpeg,image/png,image/webp"],
    extensions: [".jpg", ".jpeg", ".png", "webp"],
  },
  organization_resource: {
    name: "organization_resource",
    dbname: "file",
    accept: ["image/jpeg,image/png,image/webp"],
    extensions: [".jpg", ".jpeg", ".png", "webp", ".pdf", ".txt", ".doc", ".docx", ".xls", ".xlsx", ".csv", ".ppt", ".pptx"]
  },

  // Observation related
  observation_record: {
    name: "observation_record",
    dbname: "image",
    accept: ["image/jpeg,image/png,image/webp"],
    extensions: ["jpg", "jpeg", "png", "webp",],
  },
  observation_image: {
    name: "observation_image",
    dbname: "image",
    accept: ["image/jpeg,image/png,image/webp"],
    extensions: ["jpg", "jpeg", "png", "webp",],
  },

  // Forum related
  forum_file: {
    name: "forum_file",
    dbname: "file",
    accept: ["image/jpeg,image/png,image/webp"],
    extensions: ["jpg", "jpeg", "png", "webp",],
  },
}

export const FILE_STATUS = {
  QUEUE: "QUEUE",
  TO_UPLOAD: "TO_UPLOAD",
  UPLOADING: "UPLOADING",
  IS_UPLOADING: "IS_UPLOADING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
}

export default FILE_ACTION_TYPES
